export default __webpack_public_path__ + "static/media/calculator-header.876cba9d.jpg";